// @ts-nocheck
import React, { useEffect } from "react";
import "../assets/css/error.css";
import { useNavigate } from "react-router-dom";
import "../assets/css/product.css";
import ToiletCard from "./ToiletCard";
import ProductDesc from "./ProductDESC";
import video from '../assets/docs/video.mp4'
function JaladhijaProducts() {
  return (
    <>
      <section className="gg-page_banner">
        <div className="gg-container">
          <div className="gab_content">
            <h4 className="sub__title">Product</h4>
            <h1 className="gg-title">
              Transforming Public Sanitation <br /> in India
            </h1>
          </div>
        </div>
      </section>
      <section className="main-headding">
        <div className="container">
          <h2 className="main-head">PRODUCTS</h2>
          <p>Jaladhija and Accessories</p>
        </div>
      </section>
      <section className="cart container">
        <div className="app-container">
          <ToiletCard
            title="Jaladhija 1010 Single"
            dimensions={{
              inside: "Inside W1200 x B1200 x H2350 mm",
              outside: "Outside W1600 x B1950 x H3130 mm",
              door: "Door 600 x 24 x 1950 mm",
              cantilever: "Cantilever 450 x 1200 mm",
              footStep: "Foot Step 450 x 1200 x 250 mm",
            }}
          />
          <ToiletCard
            title="Jaladhija 1020 Double"
            dimensions={{
              inside: "Inside W1200 x B1200 x H2350 mm",
              outside: "Outside W3400 x B1500 x H3100 mm",
              door: "Door 600 x 24 x 1950 mm",
              cantilever: "Cantilever 450 x 1200 mm",
              footStep: "Foot Step 450 x 1200 x 250 mm",
            }}
            isDouble={true}
          />
          <ToiletCard
            title="Jaladhija MINI"
            dimensions={{
              inside: "Inside W1000 x B1000 x H2350 mm",
              outside: "Outside W1400 x B1850 x H3100 mm",
              door: "Door 600 x 24 x 1950 mm",
              cantilever: "Cantilever 450 x 1000 mm",
              footStep: "Foot Step 450 x 1000 x 250 mm",
            }}
          />
        </div>
      </section>
      <ProductDesc />
      <section className="video">
        <div className="container">
          <video src={video} autoPlay></video>
        </div>
      </section>
    </>
  );
}

export default JaladhijaProducts;
